import React from "react";
import { CalendarClock, MapPin, UserCheck, Loader2 } from "lucide-react";

// Real fixture strip — venue, city, kick-off (coach's local time), competition, referee. Anchored for OCTON Voice.
export const FixtureBanner = ({ fixture, teamName }) => {
  if (fixture === undefined) {
    return (
      <div className="mt-4 flex items-center gap-2 rounded-xl border border-white/10 bg-black/30 px-4 py-2.5 text-xs text-white/50"
        data-testid="fixture-banner" data-octon-section="fixture details kickoff venue stadium referee date time" data-octon-label="Fixture Details" data-octon-state="loading">
        <Loader2 size={13} className="animate-spin txt-cyan" /> Checking the real fixture…
      </div>
    );
  }
  if (!fixture) {
    return (
      <div className="mt-4 rounded-xl border border-amber-400/20 bg-amber-400/5 px-4 py-2.5 text-xs text-amber-200/80"
        data-testid="fixture-banner" data-octon-section="fixture details kickoff venue stadium referee date time" data-octon-label="Fixture Details" data-octon-state="ready">
        No scheduled fixture between these clubs found — venue below is your selection, not a confirmed match.
      </div>
    );
  }
  const homeSide = fixture.venue_for_team === "home";
  return (
    <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-1.5 rounded-xl border border-cyan-400/20 bg-cyan-400/5 px-4 py-2.5 text-xs text-white/80"
      data-testid="fixture-banner" data-octon-section="fixture details kickoff venue stadium referee date time" data-octon-label="Fixture Details" data-octon-state="ready">
      <span className="font-tac text-[9px] tracking-widest txt-cyan">REAL FIXTURE</span>
      <span className="font-semibold text-white" data-testid="fixture-banner-teams">{fixture.home.name} v {fixture.away.name}</span>
      <span className="flex items-center gap-1.5" data-testid="fixture-banner-kickoff"><CalendarClock size={13} className="txt-cyan" /> {fixture.kickoff?.local} <span className="text-white/40">({fixture.kickoff?.tz})</span></span>
      <span className="flex items-center gap-1.5" data-testid="fixture-banner-venue"><MapPin size={13} className="txt-cyan" /> {fixture.venue || "Venue TBC"}{fixture.city ? `, ${fixture.city}` : ""}
        <span className="ml-1 rounded-md px-1.5 py-0.5 font-tac text-[9px] tracking-widest" style={{ background: homeSide ? "#22d3ee22" : "#f59e0b22", color: homeSide ? "#67e8f9" : "#fcd34d" }} data-testid="fixture-banner-side">
          {teamName ? `${teamName.toUpperCase()} ${homeSide ? "HOME" : "AWAY"}` : homeSide ? "HOME" : "AWAY"}
        </span>
      </span>
      <span className="text-white/50">{fixture.league}{fixture.round ? ` · ${fixture.round.replace("Regular Season - ", "R")}` : ""}</span>
      {fixture.referee && <span className="flex items-center gap-1.5 text-white/60" data-testid="fixture-banner-ref"><UserCheck size={13} /> {fixture.referee}</span>}
    </div>
  );
};
